export type NoteRow = {
  date: unknown;
  user: string;
  note: string;
};

export function parseNotesJson(notes: string | null | undefined): NoteRow[] {
  if (notes == null || notes.trim() === '') {
    return [];
  }
  try {
    const parsed = JSON.parse(notes) as unknown;
    return Array.isArray(parsed) ? (parsed as NoteRow[]) : [];
  } catch {
    return [];
  }
}

export function formatNotesLinkLabel(noteCount: number, canAdd: boolean): string {
  if (noteCount === 0) {
    return canAdd ? 'Add note' : '';
  }
  if (noteCount === 1) {
    return '1 note';
  }
  return `${noteCount} notes`;
}
